import { Recipient } from "./SendTokenForm.component";

export const calculateTotalAmount = (recipients: Recipient[]) => {
  return recipients
    .map((rec) => rec.amount as number)
    .reduce((acc, curr) => acc + curr);
};
